/**
 * datacenter-hired — Dynamic Table of Contents
 * Ghost does not expose heading structure in Handlebars, so we build the
 * article TOC client-side from the rendered <h2> headings inside .article-content.
 * Populates [data-toc] with anchor links and adds ids to headings if missing.
 * Also wires up scroll-spy to highlight the active section.
 */
export default function toc() {
  document.addEventListener('DOMContentLoaded', function () {
    var tocTarget = document.querySelector('[data-toc]');
    var content = document.querySelector('.article-content');
    if (!tocTarget || !content) return;

    var headings = content.querySelectorAll('h2');
    if (!headings.length) {
      // No sections to list — hide the TOC block container.
      var wrap = tocTarget.closest('[data-toc-wrapper]');
      if (wrap) wrap.style.display = 'none';
      return;
    }

    function slugify(text) {
      return text.toLowerCase().trim()
        .replace(/[^\w\s-]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-');
    }

    var list = document.createElement('ul');
    list.className = 'toc-list';
    list.setAttribute('role', 'list');

    var links = [];
    headings.forEach(function (h, i) {
      if (!h.id) {
        var base = slugify(h.textContent) || ('section-' + i);
        var id = base;
        var n = 1;
        while (document.getElementById(id)) { id = base + '-' + n; n++; }
        h.id = id;
      }
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent;
      li.appendChild(a);
      list.appendChild(li);
      links.push({ a: a, h: h });
    });

    tocTarget.innerHTML = '';
    tocTarget.appendChild(list);

    // Scroll-spy
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            links.forEach(function (l) {
              l.a.classList.toggle('active', l.h === entry.target);
            });
          }
        });
      }, { rootMargin: '0px 0px -75% 0px', threshold: 0 });
      headings.forEach(function (h) { observer.observe(h); });
    }
  });
}
